<kl-grid
  [columns]="[
    {
      header: 'type' | translate,
      binding: 'type',
      width: '*',
      translate: true,
      visible: true
    },
    { header: 'code' | translate, binding: 'code', width: '*', visible: true },
    {
      header: 'description' | translate,
      binding: 'description',
      width: '*',
      visible: true
    }
  ]"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'specode',
    name: 'special_codes',
    form: 'SPECODE',
    showButton: true,
    showDropDownButton: true
  }"
  [mode]="'DIALOG'"
  [modalClass]="'modal-dialog short-modal'"
  [parentModuleName]="'APPLICATION_PARAMS'"
  [moduleName]="'SPECODE_LIST'"
  [gridName]="'grdSpecodeList'"
  [dblSelect]="dblSelect"
  [filterSelectItems]="filterSelectItems"
>
</kl-grid>
